<template>
  <div class="list-element">
    <div class="list-header">
      <span class="list-type-badge">
        <i class="fas fa-list"></i>
        <span>Liste interactive</span>
      </span>
      <div class="element-actions">
        <button class="action-btn" @click.stop="$emit('duplicate')" title="Dupliquer">
          <i class="fas fa-copy"></i>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>
    
    <div class="list-content">
      <div v-if="element.options && element.options.sections" class="list-sections">
        <div v-for="(section, secIndex) in element.options.sections" :key="secIndex" class="list-section">
          <div class="section-header" @click="$emit('edit-section', secIndex)">
            <div class="section-title">{{ section.title || 'Section sans titre' }}</div>
            <div class="section-actions">
              <button class="section-action-btn" @click.stop="$emit('edit-section', secIndex)" title="Modifier la section">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button class="section-action-btn delete" @click.stop="$emit('remove-section', secIndex)" title="Supprimer la section">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          
          <div class="section-rows">
            <div v-for="(row, rowIndex) in section.rows" :key="rowIndex" class="section-row" @click="$emit('edit-row', secIndex, rowIndex)">
              <div class="row-content">
                <div class="row-title">{{ row.title || 'Élément sans titre' }}</div>
                <div v-if="row.description" class="row-description">{{ row.description }}</div>
              </div>
              <div class="row-actions">
                <button class="row-action-btn" @click.stop="$emit('edit-row', secIndex, rowIndex)" title="Modifier l'élément">
                  <i class="fas fa-pencil-alt"></i>
                </button>
                <button class="row-action-btn delete" @click.stop="$emit('remove-row', secIndex, rowIndex)" title="Supprimer l'élément">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            
            <button class="add-row-btn" @click.stop="$emit('add-row', secIndex)">
              <i class="fas fa-plus"></i>
              <span>Ajouter un élément</span>
            </button>
          </div>
        </div>
      </div>
      
      <button class="add-section-btn" @click.stop="$emit('add-section')">
        <i class="fas fa-plus-circle"></i>
        <span>Ajouter une section</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListElement',
  props: {
    element: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>
.list-element {
  background: linear-gradient(135deg, #fff8f0 0%, #fef3e2 100%);
  border: 1px solid #fed7aa;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.list-element:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid #fed7aa;
}

.list-type-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: #c2410c;
}

.list-type-badge i {
  color: #ea580c;
}

.element-actions {
  display: flex;
  gap: 0.5rem;
}

.action-btn {
  background: white;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  width: 28px;
  height: 28px;
}

.action-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

.action-btn.delete-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}

.list-content {
  padding: 1rem;
}

.list-sections {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.list-section {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
}

.section-title {
  font-weight: 600;
  color: #212529;
}

.section-actions {
  display: flex;
  gap: 0.5rem;
}

.section-action-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: #6c757d;
}

.section-action-btn:hover {
  background: #e9ecef;
  color: #212529;
}

.section-action-btn.delete:hover {
  background: #fee2e2;
  color: #ef4444;
}

.section-rows {
  padding: 0.5rem;
}

.section-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  border-radius: 6px;
  background: #f8f9fa;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.section-row:hover {
  background: #e9ecef;
}

.row-content {
  flex: 1;
}

.row-title {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.25rem;
}

.row-description {
  font-size: 0.85rem;
  color: #6c757d;
}

.row-actions {
  display: flex;
  gap: 0.5rem;
}

.row-action-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: #6c757d;
}

.row-action-btn:hover {
  background: #dee2e6;
  color: #212529;
}

.row-action-btn.delete:hover {
  background: #fee2e2;
  color: #ef4444;
}

.add-row-btn, .add-section-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem;
  border: 1px dashed #ced4da;
  border-radius: 6px;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 0.5rem;
}

.add-section-btn {
  margin-top: 1rem;
  border-color: #fed7aa;
  color: #c2410c;
}

.add-row-btn:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
  color: #212529;
}

.add-section-btn:hover {
  background: #fff8f0;
  border-color: #fdba74;
  color: #ea580c;
}
</style>
